/* Auto-generated from CrossCanadaJax Drive (2023-2026)
   Photos sort by date (synthetic key = year-####) so order matches photo number.
*/

const photos = [
  { src: "/gallery/2023/001.jpg", date: "2023-0001" },
  { src: "/gallery/2023/002.jpg", date: "2023-0002" },
  { src: "/gallery/2023/003.jpg", date: "2023-0003" },
  { src: "/gallery/2023/004.jpg", date: "2023-0004" },
  { src: "/gallery/2023/005.jpg", date: "2023-0005" },
  { src: "/gallery/2023/006.jpg", date: "2023-0006" },
  { src: "/gallery/2023/007.jpg", date: "2023-0007" },
  { src: "/gallery/2023/008.jpg", date: "2023-0008" },
  { src: "/gallery/2023/009.jpg", date: "2023-0009" },
  { src: "/gallery/2023/010.jpg", date: "2023-0010" },
  { src: "/gallery/2023/011.jpg", date: "2023-0011" },
  { src: "/gallery/2023/012.jpg", date: "2023-0012" },
  { src: "/gallery/2023/013.jpg", date: "2023-0013" },
  { src: "/gallery/2023/014.jpg", date: "2023-0014" },
  { src: "/gallery/2023/015.jpg", date: "2023-0015" },
  { src: "/gallery/2023/016.jpg", date: "2023-0016" },
  { src: "/gallery/2023/017.jpg", date: "2023-0017" },
  { src: "/gallery/2023/018.jpg", date: "2023-0018" },
  { src: "/gallery/2023/019.jpg", date: "2023-0019" },
  { src: "/gallery/2023/020.jpg", date: "2023-0020" },
  { src: "/gallery/2023/021.jpg", date: "2023-0021" },
  { src: "/gallery/2023/022.jpg", date: "2023-0022" },
  { src: "/gallery/2023/023.jpg", date: "2023-0023" },
  { src: "/gallery/2023/024.jpg", date: "2023-0024" },
  { src: "/gallery/2023/025.jpg", date: "2023-0025" },
  { src: "/gallery/2023/026.jpg", date: "2023-0026" },
  { src: "/gallery/2023/027.jpg", date: "2023-0027" },
  { src: "/gallery/2023/028.jpg", date: "2023-0028" },
  { src: "/gallery/2023/029.jpg", date: "2023-0029" },
  { src: "/gallery/2023/030.jpg", date: "2023-0030" },
  { src: "/gallery/2023/031.jpg", date: "2023-0031" },
  { src: "/gallery/2023/032.jpg", date: "2023-0032" },
  { src: "/gallery/2023/033.jpg", date: "2023-0033" },
  { src: "/gallery/2023/034.jpg", date: "2023-0034" },
  { src: "/gallery/2023/035.jpg", date: "2023-0035" },
  { src: "/gallery/2023/036.jpg", date: "2023-0036" },
  { src: "/gallery/2023/037.jpg", date: "2023-0037" },
  { src: "/gallery/2023/038.jpg", date: "2023-0038" },
  { src: "/gallery/2023/039.jpg", date: "2023-0039" },
  { src: "/gallery/2023/040.jpg", date: "2023-0040" },
  { src: "/gallery/2023/041.jpg", date: "2023-0041" },
  { src: "/gallery/2023/042.jpg", date: "2023-0042" },
  { src: "/gallery/2023/043.jpg", date: "2023-0043" },
  { src: "/gallery/2023/044.jpg", date: "2023-0044" },
  { src: "/gallery/2023/045.jpg", date: "2023-0045" },
  { src: "/gallery/2023/046.jpg", date: "2023-0046" },
  { src: "/gallery/2023/047.jpg", date: "2023-0047" },
  { src: "/gallery/2023/048.jpg", date: "2023-0048" },
  { src: "/gallery/2023/049.jpg", date: "2023-0049" },
  { src: "/gallery/2023/050.jpg", date: "2023-0050" },
  { src: "/gallery/2023/051.jpg", date: "2023-0051" },
  { src: "/gallery/2023/052.jpg", date: "2023-0052" },
  { src: "/gallery/2023/053.jpg", date: "2023-0053" },
  { src: "/gallery/2023/054.jpg", date: "2023-0054" },
  { src: "/gallery/2023/055.jpg", date: "2023-0055" },
  { src: "/gallery/2023/056.jpg", date: "2023-0056" },
  { src: "/gallery/2023/057.jpg", date: "2023-0057" },
  { src: "/gallery/2023/058.jpg", date: "2023-0058" },
  { src: "/gallery/2023/059.jpg", date: "2023-0059" },
  { src: "/gallery/2023/060.jpg", date: "2023-0060" },
  { src: "/gallery/2023/061.jpg", date: "2023-0061" },
  { src: "/gallery/2023/062.jpg", date: "2023-0062" },
  { src: "/gallery/2023/063.jpg", date: "2023-0063" },
  { src: "/gallery/2023/064.jpg", date: "2023-0064" },
  { src: "/gallery/2023/065.jpg", date: "2023-0065" },
  { src: "/gallery/2023/066.jpg", date: "2023-0066" },
  { src: "/gallery/2023/067.jpg", date: "2023-0067" },
  { src: "/gallery/2023/068.jpg", date: "2023-0068" },
  { src: "/gallery/2023/069.jpg", date: "2023-0069" },
  { src: "/gallery/2023/070.jpg", date: "2023-0070" },
  { src: "/gallery/2023/071.jpg", date: "2023-0071" },
  { src: "/gallery/2023/072.jpg", date: "2023-0072" },
  { src: "/gallery/2023/073.jpg", date: "2023-0073" },
  { src: "/gallery/2023/074.jpg", date: "2023-0074" },
  { src: "/gallery/2023/075.jpg", date: "2023-0075" },
  { src: "/gallery/2023/076.jpg", date: "2023-0076" },
  { src: "/gallery/2023/077.jpg", date: "2023-0077" },
  { src: "/gallery/2023/078.jpg", date: "2023-0078" },
  { src: "/gallery/2023/079.jpg", date: "2023-0079" },
  { src: "/gallery/2023/080.jpg", date: "2023-0080" },
  { src: "/gallery/2023/081.jpg", date: "2023-0081" },
  { src: "/gallery/2023/082.jpg", date: "2023-0082" },
  { src: "/gallery/2023/083.jpg", date: "2023-0083" },
  { src: "/gallery/2023/084.jpg", date: "2023-0084" },
  { src: "/gallery/2023/085.jpg", date: "2023-0085" },
  { src: "/gallery/2023/086.jpg", date: "2023-0086" },
  { src: "/gallery/2023/087.jpg", date: "2023-0087" },
  { src: "/gallery/2023/088.jpg", date: "2023-0088" },
  { src: "/gallery/2023/089.jpg", date: "2023-0089" },
  { src: "/gallery/2023/090.jpg", date: "2023-0090" },
  { src: "/gallery/2023/091.jpg", date: "2023-0091" },
  { src: "/gallery/2023/092.jpg", date: "2023-0092" },
  { src: "/gallery/2023/093.jpg", date: "2023-0093" },
  { src: "/gallery/2023/094.jpg", date: "2023-0094" },
  { src: "/gallery/2023/095.jpg", date: "2023-0095" },
  { src: "/gallery/2023/096.jpg", date: "2023-0096" },
  { src: "/gallery/2023/097.jpg", date: "2023-0097" },
  { src: "/gallery/2023/098.jpg", date: "2023-0098" },
  { src: "/gallery/2023/099.jpg", date: "2023-0099" },
  { src: "/gallery/2023/100.jpg", date: "2023-0100" },
  { src: "/gallery/2023/101.jpg", date: "2023-0101" },
  { src: "/gallery/2023/102.jpg", date: "2023-0102" },
  { src: "/gallery/2023/103.jpg", date: "2023-0103" },
  { src: "/gallery/2023/104.jpg", date: "2023-0104" },
  { src: "/gallery/2023/105.jpg", date: "2023-0105" },
  { src: "/gallery/2023/106.jpg", date: "2023-0106" },
  { src: "/gallery/2023/107.jpg", date: "2023-0107" },
  { src: "/gallery/2023/108.jpg", date: "2023-0108" },
  { src: "/gallery/2023/109.jpg", date: "2023-0109" },
  { src: "/gallery/2023/110.jpg", date: "2023-0110" },
  { src: "/gallery/2023/111.jpg", date: "2023-0111" },
  { src: "/gallery/2023/112.jpg", date: "2023-0112" },
  { src: "/gallery/2023/113.jpg", date: "2023-0113" },
  { src: "/gallery/2023/114.jpg", date: "2023-0114" },
  { src: "/gallery/2023/115.jpg", date: "2023-0115" },
  { src: "/gallery/2023/116.jpg", date: "2023-0116" },
  { src: "/gallery/2023/117.jpg", date: "2023-0117" },
  { src: "/gallery/2023/118.jpg", date: "2023-0118" },
  { src: "/gallery/2023/119.jpg", date: "2023-0119" },
  { src: "/gallery/2023/120.jpg", date: "2023-0120" },
  { src: "/gallery/2023/121.jpg", date: "2023-0121" },
  { src: "/gallery/2023/122.jpg", date: "2023-0122" },
  { src: "/gallery/2023/123.jpg", date: "2023-0123" },
  { src: "/gallery/2023/124.jpg", date: "2023-0124" },
  { src: "/gallery/2023/125.jpg", date: "2023-0125" },
  { src: "/gallery/2023/126.jpg", date: "2023-0126" },
  { src: "/gallery/2023/127.jpg", date: "2023-0127" },
  { src: "/gallery/2023/128.jpg", date: "2023-0128" },
  { src: "/gallery/2024/001.jpg", date: "2024-0001" },
  { src: "/gallery/2024/002.jpg", date: "2024-0002" },
  { src: "/gallery/2024/003.jpg", date: "2024-0003" },
  { src: "/gallery/2024/004.jpg", date: "2024-0004" },
  { src: "/gallery/2025/001.jpg", date: "2025-0001" },
  { src: "/gallery/2025/002.jpg", date: "2025-0002" },
  { src: "/gallery/2025/003.jpg", date: "2025-0003" },
  { src: "/gallery/2025/004.jpg", date: "2025-0004" },
  { src: "/gallery/2025/006.jpg", date: "2025-0006" },
  { src: "/gallery/2026/001.jpg", date: "2026-0001" },
  { src: "/gallery/2026/002.jpg", date: "2026-0002" },
  { src: "/gallery/2026/003.jpg", date: "2026-0003" },
  { src: "/gallery/2026/004.jpg", date: "2026-0004" },
  { src: "/gallery/2026/005.jpg", date: "2026-0005" },
  { src: "/gallery/2026/006.jpg", date: "2026-0006" },
  { src: "/gallery/2026/007.jpg", date: "2026-0007" },
  { src: "/gallery/2026/008.jpg", date: "2026-0008" },
  { src: "/gallery/2026/009.jpg", date: "2026-0009" },
  { src: "/gallery/2026/010.jpg", date: "2026-0010" },
  { src: "/gallery/2026/011.jpg", date: "2026-0011" },
  { src: "/gallery/2026/012.jpg", date: "2026-0012" },
  { src: "/gallery/2026/013.jpg", date: "2026-0013" },
  { src: "/gallery/2026/014.jpg", date: "2026-0014" },
  { src: "/gallery/2026/015.jpg", date: "2026-0015" },
  { src: "/gallery/2026/016.jpg", date: "2026-0016" },
  { src: "/gallery/2026/017.jpg", date: "2026-0017" },
  { src: "/gallery/2026/018.jpg", date: "2026-0018" },
  { src: "/gallery/2026/019.jpg", date: "2026-0019" },
  { src: "/gallery/2026/020.jpg", date: "2026-0020" },
  { src: "/gallery/2026/021.jpg", date: "2026-0021" },
];

export default photos;
